var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMicrowave = function SvgIconMicrowave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1104 792",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M972 0H132C58.8 0 0 58.8 0 132v528c0 73.2 58.8 132 132 132h840c73.2 0 132-58.8 132-132V132c0-73.2-58.8-132-132-132Zm60 660c0 33.6-26.4 60-60 60H132c-33.6 0-60-26.4-60-60V132c0-33.6 26.4-60 60-60h840c33.6 0 60 26.4 60 60v528Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M696 132H192c-26.4 0-48 21.6-48 48v432c0 26.4 21.6 48 48 48h504c26.4 0 48-21.6 48-48V180c0-26.4-21.6-48-48-48ZM804 408h168v72H804v-72ZM804 528h168v72H804v-72ZM984 276c0 53.02-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.98 96 96"
  })));
};
export default SvgIconMicrowave;